<template>
  <Actions>
    <slot></slot>
  </Actions>
</template>

<script>
import Actions from '@/components/Actions.vue'

export default {
  name: 'DialogActions',
  components: { Actions },
}
</script>
